import React from "react";
import { inject, observer } from "mobx-react";
import PurchaseOrderSettingsEdit from "./PurchaseOrderSettingsEdit";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

@inject("store")
@observer

export default class PurchaseOrderSettings extends React.Component {

    constructor(props) {
        super(props);

        this.goBack = this.goBack.bind(this);
        this.state = {
            //orderTemplates: [],
            allowDateChange: false,
            editOrder: false,
            editOrderReference: ""
        };
    }

    goBack(e) {
        e.preventDefault();
        const navigation = this.props.store.navigation;
        //console.log("beginPurchase selectedSiteUrl: ", this.state.selectedSiteUrl);
        //navigation.openPurchaseOrder();
        //navigation.closeToolbar(true);
        navigation.mainRouter.goBack();
        
    }



    render() {
        const account = this.props.store.account;
        const orderStore = this.props.store.order;
        if (!account.Ready) {
            return (<div>Laddar ...</div>);
        }
        return (

            <React.Fragment>

                {this.state.editOrder
                    ? null
                    : <React.Fragment>
                        <h4 className="card-title text-center my-3">
                            Skapa en ny beställningsorder eller välj en befintlig
                            </h4>

                        <div className="form-group text-center my-5">
                            <button className="btn btn-success"
                                onClick={(e) => {
                                    orderStore.addOrder(this.state.selectedSiteId).then(success => {
                                        this.setState({ editOrder: true });
                                    },
                                        error => { alert(error.message) });
                                }}>Planera en ny beställning</button>


                        </div>
                        {(orderStore.Orders.length > 0) &&
                            <div
                                style={{ display: "flex" }}>
                                <select
                                    className="form-control form-control-sm mb-3"
                                    value={orderStore.activeOrder ? orderStore.activeOrder.OrderGuid : ""}
                                    onChange={(e) => {
                                        orderStore.getOrder(e.target.value, true);
                                    }}>
                                    {orderStore.Orders.map(order => (
                                        <option key={order.OrderGuid} value={order.OrderGuid}>{order.OrderNumber} {order.Reference ? ` - (${order.Reference})`
                                            : ""}</option>
                                    ))}
                                </select>



                                {/*<button disabled={!(orderStore.activeOrder && orderStore.activeOrder.OrderTemplateName)
                                } className="btn btn-primary btn-sm my-0 mr-0 ml-2 px-2" onClick={this.beginPurchase}>EDIT ORDER</button>
                                */}

                                <button
                                    disabled={!orderStore.activeOrder}
                                    className="btn btn-secondary btn-sm my-0 mr-0 ml-2 px-2"
                                    onClick={(e) => {
                                        this.setState({ editOrder: true });

                                    }}><i className="material-icons edit "></i></button>
                                <button
                                    disabled={!orderStore.activeOrder}
                                    className="btn btn-secondary btn-sm my-0 mr-0 ml-2 px-2"
                                    onClick={(e) => {
                                        if (confirm("Are you sure that you want to delete order: " +
                                            orderStore.activeOrder.OrderNumber)) {
                                            orderStore.deleteOrder(this.state.selectedSiteId, orderStore.activeOrder.OrderGuid).then(
                                                success => {
                                                    // todo: display a message
                                                },
                                                error => { alert(error.message) });
                                        }
                                    }}><i className="material-icons delete"></i></button>
                            </div>
                        }
                    </React.Fragment>
                }

                {!orderStore.activeOrder
                    ? null
                    : <React.Fragment>
                        {!this.state.editOrder
                            ? null
                            : <PurchaseOrderSettingsEdit />
                        }

                    </React.Fragment>
                }

                <div className="form-group text-center">
                    
                    {(orderStore.activeOrder) && <button
                        onClick={() => {
                            this.props.store.navigation.mainRouter.goBack();
                        }}
                        style={{flex:"0 0 33%"}}
                        className="btn btn-light mr-2"
                    >
                        <FontAwesomeIcon icon={["fas", "angle-left"]} /> Varukorg

                    </button> 
                        
                        // <button disabled={!(orderStore.activeOrder)}
                        //                                  className="btn btn-success mr-2" onClick={this.beginPurchase}></button>
                    }

                    
                    
                    {this.state.editOrder && <button className="btn btn-secondary"
                        onClick={(e) => {
                            this.setState({ editOrder: false });
                        }}>Tillbaka till orderlistan</button>
                    }

                    

                </div>



            </React.Fragment>


        );
    }

}